export class Report {
    public number: string;
    public comment: string;
}


// WEBPACK FOOTER //
// /app/SPA/src/app/models/report.ts